import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AppShell from "./components/AppShell";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Onboarding from "./pages/Onboarding";
import Discover from "./pages/Discover";
import Matches from "./pages/Matches";
import ChatPage from "./pages/ChatPage";
import ProfilePage from "./pages/ProfilePage";
import PremiumPage from "./pages/PremiumPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";

const Protected = ({ children, requireOnboarded = true }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center">
        <p className="font-serif text-2xl text-[#8A8A8A]">Evervow</p>
      </div>
    );
  if (user === false) return <Navigate to="/auth?mode=login" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/account-deletion" element={<DeleteAccountPage />} />
          <Route
            path="/onboarding"
            element={
              <Protected requireOnboarded={false}>
                <Onboarding />
              </Protected>
            }
          />
          <Route
            path="/discover"
            element={
              <Protected>
                <AppShell>
                  <Discover />
                </AppShell>
              </Protected>
            }
          />
          <Route
            path="/matches"
            element={
              <Protected>
                <AppShell>
                  <Matches />
                </AppShell>
              </Protected>
            }
          />
          <Route
            path="/chat/:matchId"
            element={
              <Protected>
                <AppShell>
                  <ChatPage />
                </AppShell>
              </Protected>
            }
          />
          <Route
            path="/premium"
            element={
              <Protected>
                <AppShell>
                  <PremiumPage />
                </AppShell>
              </Protected>
            }
          />
          <Route
            path="/profile"
            element={
              <Protected>
                <AppShell>
                  <ProfilePage />
                </AppShell>
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
